import { AlertTriangle } from "lucide-react";

interface DailyLimitWarningProps {
  remaining: number;
  percentage: number;
  resets_at: string;
}

function formatTokens(tokens: number): string {
  if (tokens >= 1000) {
    return `${Math.round(tokens / 1000)}k`;
  }
  return tokens.toString();
}

function formatResetTime(resets_at: string): string {
  const resetDate = new Date(resets_at);
  const now = new Date();
  const diffMs = resetDate.getTime() - now.getTime();
  const diffHours = Math.ceil(diffMs / (1000 * 60 * 60));

  if (diffHours <= 1) {
    const diffMinutes = Math.ceil(diffMs / (1000 * 60));
    return `${diffMinutes} min`;
  }
  return `${diffHours}h`;
}

export function DailyLimitWarning({ remaining, percentage, resets_at }: DailyLimitWarningProps) {
  return (
    <div className="absolute left-2 bottom-2 flex items-center gap-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-2 py-1 z-10">
      <AlertTriangle className="w-3.5 h-3.5 text-amber-500" />
      <span>
        {Math.round(percentage)}% utilise ({formatTokens(remaining)} restants) - Reset dans {formatResetTime(resets_at)}
      </span>
    </div>
  );
}
